import { useCallback, useEffect, useRef } from "react";
import { useChatStore } from "../../state/chat";
import { useChatActions } from "../../state/chatActions";
import { ChatInput } from "./ChatInput";
import { ChatStream } from "./ChatStream";
import styles from "./ChatPane.module.css";

interface ChatPaneProps {
  onSend?: (text: string) => void;
}

export function ChatPane({ onSend }: ChatPaneProps) {
  const mode = useChatStore((s) => s.mode);
  const append = useChatStore((s) => s.append);

  const placeholder =
    mode === "cinematic"
      ? "ripper is working the overnight scan…"
      : mode === "thinking"
        ? "thinking…"
        : "ask me about the portfolio.";

  const handleSend = useCallback(
    (text: string) => {
      append({ id: `user-${Date.now()}`, kind: "user", text });
      if (onSend) onSend(text);
    },
    [append, onSend]
  );

  // Register a stable wrapper globally so panel widgets can dispatch queries
  // without prop-drilling. Re-pointed to latest handleSend via ref.
  const handleRef = useRef(handleSend);
  handleRef.current = handleSend;
  useEffect(() => {
    useChatActions.getState().register((text) => handleRef.current(text));
    return () => {
      useChatActions.getState().register(() => {});
    };
  }, []);

  return (
    <div className={styles.pane}>
      <ChatStream onSend={handleSend} />
      <ChatInput
        placeholder={placeholder}
        disabled={mode !== "listening"}
        onSend={handleSend}
      />
    </div>
  );
}
